module.exports = __webpack_public_path__ + "img/ear.1bd2d42.png";